import { ListLayout } from "@/components/custom/list-layout/list-layout";
import { useOrgProjectRouteContext } from "@/lib/org-project-context/hooks";
import { useGetApiKeys } from "./api/hooks";
import { CreateApiKeyDialog } from "./components/create/create-dialog";
import { ApiKeysTable } from "./components/table/api-keys-table";

export const ApiKeysList = () => {
  const { organizationId, projectId } = useOrgProjectRouteContext();
  const { data: apiKeys } = useGetApiKeys(projectId, organizationId);

  return (
    <ListLayout
      actions={<CreateApiKeyDialog />}
      description="Manage the API keys for this project. Create new keys to securely access Arcade's features, view existing ones, or revoke access when needed."
      title="API Keys"
    >
      <ApiKeysTable items={apiKeys?.data.items ?? []} stickyColumnBg="card" />
    </ListLayout>
  );
};
